import { render, staticRenderFns } from "./gb-whatsapp-old-version.vue?vue&type=template&id=0657a6d4&scoped=true"
import script from "./gb-whatsapp-old-version.vue?vue&type=script&lang=js"
export * from "./gb-whatsapp-old-version.vue?vue&type=script&lang=js"
import style0 from "./gb-whatsapp-old-version.vue?vue&type=style&index=0&id=0657a6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0657a6d4",
  null
  
)

export default component.exports